import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import "./style.scss";
import BodyText from "../../elements/body-text";

function PdpButton({ width, isDisabled, isSelected, buttonText, optText, uspHtml, id, handleSelection, className }) {
  const handleClick = event => {
    handleSelection(event, id);
  };

  const classes = classNames("pdp-button-container", width, {
    disabled: isDisabled,
    selected: isSelected
  });

  const uspClasses = classNames(`usp-list`, ` ${isSelected ? "selected" : ""}`);

  return (
    <div className={classes} onClick={evt => handleClick(evt)}>
      <button className={classNames("pdp-button", className)} tabIndex="0" id={id}>
        <span className="pdp-button__content" tabIndex="-1">
          {buttonText != null && <span className="button-text">{buttonText}</span>}
          {optText != null && <span className="opt-text" dangerouslySetInnerHTML={{ __html: optText }} />}
        </span>
      </button>
      {uspHtml != null && <BodyText tagName={"ul"} className={uspClasses} html={uspHtml} />}
    </div>
  );
}

PdpButton.propTypes = {
  handleSelection: PropTypes.func,
  width: PropTypes.string,
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  buttonText: PropTypes.string,
  optText: PropTypes.string,
  // uspHtml: PropTypes.string,
  id: PropTypes.string
};

PdpButton.defaultProps = {
  callback: () => {}
};

export default PdpButton;
